import { Link } from "react-router-dom";
import { LogotipoHorizontalNaranja } from "@wasom/brand";

export function SiteHeader() {
  return (
    <header className="sticky top-0 z-10 border-b backdrop-blur" style={{ borderColor: "var(--border)", background: "color-mix(in oklab, var(--bg) 85%, transparent)" }}>
      <div className="mx-auto flex max-w-6xl items-center justify-between px-6 py-4">
        <Link to="/" aria-label="WASOM — inicio">
          <LogotipoHorizontalNaranja style={{ height: 28, width: "auto" }} />
        </Link>
        <nav className="hidden items-center gap-8 text-sm font-medium sm:flex" style={{ color: "var(--text-2)" }}>
          <a href="#producto" className="hover:opacity-80" style={{ transitionDuration: "var(--motion-fast)" }}>
            Producto
          </a>
          <a href="#como-funciona" className="hover:opacity-80" style={{ transitionDuration: "var(--motion-fast)" }}>
            Cómo funciona
          </a>
          <a href="#capas" className="hover:opacity-80" style={{ transitionDuration: "var(--motion-fast)" }}>
            Plataforma
          </a>
        </nav>
        <div className="flex items-center gap-3">
          {/* Entrar apunta al build de apps/console, servido en /app/** por
              Firebase Hosting (firebase.json rewrites) — no es una ruta de
              este router, por eso <a> y no <Link>. */}
          <a
            href="/app/login"
            className="rounded-[var(--radius-md)] border px-4 py-2 text-sm font-semibold"
            style={{ borderColor: "var(--border)", color: "var(--text-1)" }}
          >
            Entrar
          </a>
          <Link to="/contacto">
            <button
              className="rounded-[var(--radius-md)] px-4 py-2 text-sm font-semibold"
              style={{ background: "var(--brand)", color: "var(--brand-on)" }}
            >
              Hablemos de tu operación
            </button>
          </Link>
        </div>
      </div>
    </header>
  );
}
